import { useState,useEffect,useContext} from 'react';
import { useLocation,Link,useNavigate } from 'react-router-dom';
import { PassContext } from '../../../../hooks/PassContext';
import axios from 'axios';
import "./Review.css";
import { Stepper } from './Stepper';
import { CART_BASE_URL,ORDER_BASE_URL } from '../../../../config/ApiConfig';
import { showNotification } from '../../../../services/NotificationService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const Review = ()=>{
    const location = useLocation();
    const { types,error } = useContext(PassContext);
    const [passItem,setPassItem] = useState([]);
    const [cartItems,setCartItems]=useState([]);
    const [email,setEmail] = useState('');
    const [shippingData,setShippingData]=useState({});
    const [billingData,setBillingData]=useState({});
    const [errorMessage,setErrorMessage]= useState('');
    const [loadingMessage, setLoadingMessage] = useState('');
    const {cartId,cartGUID,paymentDetail,hasAnnualPass} = location.state;
    const navigate=useNavigate();
    const [isDisabled, setIsDisabled] = useState(false); // Start with able as false
    const [hasError, setHasError] = useState('');

    useEffect(()=>{
        setHasError('');
        if (!types || types.length === 0) {
            return;
        }
        const fetchOrderDetails = async () => {
            try {
                const response = await axios.get(`${CART_BASE_URL}/GetCartDetailsByGUID/${cartGUID}`);
                const { shippingDetails} = response.data.data.cartDetails || {};
                setShippingData(shippingDetails);
                const { emailId } = response.data.data.cartDetails || '';
                setEmail(emailId);
                const {billingDetails} = response.data.data.cartDetails;
                setBillingData(billingDetails);
                const savedResponseForCart = response.data.data.cartDetails.passes;
                setCartItems(savedResponseForCart);
                // Filter types to only include passes that exist in savedResponseForCart
                const filteredTypes = types.filter(type => {
                    return(
                        savedResponseForCart.some(order => order.passID === type.passID)
                    )
                });
                const mergedOrdersData = filteredTypes.map(type => {
                    // Find the first matching order for this passID in savedResponseForCart
                    const matchingOrder = savedResponseForCart.find(order => order.passID === type.passID);
                    // Combine type data with the matching order information
                    return {
                        ...type,
                        quantity: matchingOrder ? matchingOrder.quantity : 0,
                        passDate: matchingOrder ? matchingOrder.passDate : null,
                    };
                });
                setPassItem(mergedOrdersData);
            } catch (error) {
                console.error('Error fetching order details:', error);
                showNotification("Oops! Something went wrong. Please try again later.","error");
                setHasError(`We're unable to review the Order at the moment. Please try refreshing the page or come back later.`)
            }
        };
        fetchOrderDetails();
    },[types,cartGUID]);

    useEffect(() => {
        if (error) {  // Show error only if the API call has failed
            setHasError('Something went Wrong. Please refresh the page or try again later');
        } else {
            setHasError('');
        }
    }, [error]);

    // Group items by passID for dynamic handling
    const passGroups = cartItems.reduce((groups, item) => {
        const passID = item.passID;
        if (!groups[passID]) {
            groups[passID] = [];
        }
        groups[passID].push(item);
        return groups;
    }, {});

    // Calculate totals dynamically
    const orderSummary = Object.keys(passGroups).map(passID => {
        const items = passGroups[passID];
        const pass = passItem.find(item => item.passID === Number(passID));
        // Check if it’s a One Day Pass or Annual Pass
        if (pass.passID === 1) { // Annual Pass
            // For Annual Pass, group the items 
            const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
            const totalPrice = items.reduce((sum, item) => sum + (item.perUnitPrice + item.processingFee) * item.quantity, 0);
            return {
                passID: Number(passID),
                quantity,
                totalPrice,
                passName: pass.longName
            };
        } else { // One Day Pass
            // For One Day Pass, display each pass individually
            return items.map(item => ({
                passID: Number(passID),
                quantity: item.quantity, // Each item is shown individually, so quantity is 1 for each pass
                totalPrice: (item.perUnitPrice + item.processingFee) * item.quantity,
                passName: pass.longName,
                passDate: item.passDate, // Include the date for the one day pass
            }));
        }
    }).flat(); // Flatten the array in case of one day passes to avoid nested arrays    

    //Grand total calculation
    const grandTotal = orderSummary.reduce((sum, item) => sum + item.totalPrice, 0);
    const totalProcessingFee = cartItems.reduce((total, item) => total + item.processingFee * item.quantity, 0);
    const hasPassIdOne = cartItems.some(item => item.passID === 1);
    const orderHandle=async()=>{
        setIsDisabled(true);
        setLoadingMessage('Payment is in progress. Please wait while we process your order...');
        setErrorMessage('');
        const orderDetail={
            cartGUID:cartGUID,
            payment: {
                cardNumber: paymentDetail.cardNumber,
                expirationDate: `${paymentDetail.month}/${paymentDetail.year}`,
                cvv: paymentDetail.cvv
            }
        };
        try {
            const response = await axios.post(`${ORDER_BASE_URL}/PlaceOrder`, orderDetail, {
                headers: {
                    "Content-Type": "application/json"
                }
            });    
            const transactionId = response.data.data.paymentResponse.transactionID;
    
            if (response.data.statusId === 200) {
                showNotification(response.data.message,"success")
                sessionStorage.removeItem("wa_crt_itms");
                navigate('/order-summary', { state: { transactionId,isOrderCompleted: true } });
            } else {
                setErrorMessage("Payment Failed.Please update the payment details and try again");
            }
        } catch (error) {
            console.error('Error placing the order:', error);
            setErrorMessage("Payment Failed.Please update the payment details and try again");
            showNotification("Payment Failed.Please update the payment details and try again","error");

        } finally {
            setIsDisabled(false); // Set able to false once the API response is received (success or failure)
            setLoadingMessage(''); // Clear loading message after response
        }
    }
    return(
        <>
            <div className='review-container my-5'>
                <div className='main-review'>
                {hasError?<><h2 className='errorHandled'>{hasError}</h2></>:
                    cartItems.length === 0 ? (
                        <div className="skeleton-wrapper d-flex flex-column">
                            <Skeleton height={30} width="100px" />
                            <Skeleton height={15} width="60%" />
                            <Skeleton height={15} width="50%" />
                            <Skeleton height={100} width="100%" />
                            <Skeleton height={30} width="40%" />
                            <Skeleton count={5} width="80%" />
                        </div>
                    ) :<>
                    <Stepper currentStep={3}></Stepper>
                    <h2 className='review-heading'>Review Your Order</h2>
                    <div className="content">
                        <>
                            <div className='review-cols'>
                                <div className='review-wrap'>
                                    <div className="review-col">
                                        {
                                            passItem && passItem.map((item) => {
                                                const getExpirationDate = () => {
                                                    let today = new Date(); // Get current date in local timezone
                                                    let count = 0;
                                                    // Convert to UTC to avoid timezone shifts
                                                    today = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
                                                
                                                    // Increment the date by 1 day while excluding weekends
                                                    while (count < 15) {
                                                        today.setUTCDate(today.getUTCDate() + 1);
                                                
                                                        // Check if the new date is a weekend
                                                        if (today.getUTCDay() !== 6 && today.getUTCDay() !== 0) {
                                                            count++;
                                                        }
                                                    }                                                
                                                    // Format the date in UTC to ensure consistency
                                                    const options = { year: 'numeric', month: 'long', day: '2-digit', timeZone: 'UTC' };
                                                    let formattedDate = today.toLocaleDateString('en-US', options);
                                                
                                                    formattedDate = formattedDate.replace(/(\w+)(\s)/, "$1 ");
                                                    return formattedDate;
                                                };
                                                return (
                                                    <div key={item.passID} className='review-data'>
                                                        <h2>{item.longName}</h2>
                                                        <p>
                                                            {item.passID === 1 ? <>Your annual Discover Pass will be sent to you via USPS First Class Mail on or before <strong>{getExpirationDate()}</strong>.<br/><br/>
                                                        A temporary pass will be emailed to you and expires on <strong>{getExpirationDate()}.</strong> After finalizing your purchase, you can download and print your temporary pass for immediate use. If you are unable to print, write the transaction number and date from your email receipt on a piece of paper in large bold print and display it on your car's dashboard until you receive the pass in the mail. </>:
                                                                `Your one-day Discover Pass will be sent to you via email and will be printable at the end of the checkout process. You can download and print your pass for immediate use. If you are unable to print, write the transaction number and date on a piece of paper in large bold print and display it on your car's dashboard.`}
                                                        </p>
                                                    </div>
                                                )
                                            })
                                        }
                                        <h2 className='review-email'>Your passes will be emailed to:</h2>
                                        <p className='email'>{email}<br/><Link to={`/delivery`}  className="edit edit-left" state={{ passItem: passItem,cartId: cartId,cartGUID:cartGUID}}>Edit</Link></p>
                                    </div>
                                    
                                    <div className="review-col review-data">
                                    {/* For Shipping */}
                                    {
                                        hasPassIdOne && shippingData &&<>
                                            <h2>Shipping Address <Link to={`/delivery`} className="edit" state={{ passItem: passItem,cartId: cartId,cartGUID:cartGUID}}>Edit</Link></h2>
                                            <p>{shippingData.shippingFirstName} {shippingData.shippingLastName},<br/>
                                                {shippingData.shippingAddress1},<br/>
                                                {shippingData.shippingAddress2 && <>{shippingData.shippingAddress2},<br/></>}
                                                {shippingData.shippingCity}, {shippingData.shippingState},{shippingData.shippingZip}<br/>
                                                {shippingData.shippingCountry}<br/>
                                            </p>
                                        </>
                                    }                                        
                                    {/* For Billing */}
                                        {
                                            billingData && <>
                                                <h2>Billing Address <Link to={`/billing`} className="edit" state={{ cartId: cartId,hasAnnualPass:hasAnnualPass,cartGUID:cartGUID}}>Edit</Link></h2>
                                                <p>{billingData.billingFirstName} {billingData.billingLastName},<br/>
                                                    {billingData.billingAddress1},<br/>
                                                    {billingData.billingAddress2 && <>{billingData.billingAddress2},<br/></>}
                                                    {billingData.billingCity}, {billingData.billingState},{billingData.billingZip}<br/>
                                                    {billingData.billingCountry}<br/>
                                                </p>
                                            </>
                                        }
                                    {/* For Payment */}
                                        <h2 className={errorMessage ? "errorStyle" : ""}>Payment Details <Link to ={`/billing`} className="edit" state={{ cartId: cartId,hasAnnualPass:hasAnnualPass,cartGUID:cartGUID}}>Edit</Link></h2>
                                        <p>Card ending in {paymentDetail.cardNumber.slice(-4)}<br/> Expires {paymentDetail.month}/{paymentDetail.year}</p>
                                    </div>
                                </div>                                
                                {/* For Order */}
                                <div className="review-col review-col-order review-data" style={{width:"33%"}}>
                                    <h2>Order Total</h2>
                                    <div className="review-order">

                                        {orderSummary && orderSummary.map((item) => (
                                            <div key={item.passID + (item.passDate || '')} className="order-items">
                                                <div className="order-item-product">
                                                    {item.passName} {` (${item.quantity})`} 
                                                    {item.passDate && (
                                                        <div className="order-item-date">
                                                            {`( ${new Date(item.passDate).toLocaleDateString('en-US', {
                                                                weekday: 'long',
                                                                month: 'long', 
                                                                day: 'numeric', 
                                                                year: 'numeric'
                                                            })} )`}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="order-item-subtotal">${item.totalPrice.toFixed(2)}</div>
                                            </div>
                                        ))}
                                        <div className="review-order-total">
                                            <strong>Order Total: ${grandTotal.toFixed(2)}</strong><br/>
                                            Total processing fee of ${totalProcessingFee.toFixed(2)} included
                                        </div>
                                    </div>
                                    <button id="placeOrderButton" className="add-button" onClick={orderHandle} disabled={isDisabled || !!errorMessage}>Place Order</button> 
                                    {
                                    loadingMessage && 
                                    <p className="loadingMessage" style={{color: "#fd821e",fontSize:"19px",fontWeight:"700"}}>{loadingMessage}</p>
                                    }
                                    {
                                        errorMessage && <>
                                        <h2 className='paymentError'>{errorMessage}</h2>
                                        </>
                                    }
                                </div>
                            </div>
                        </>
                    </div>
                    </>}
                </div>
            </div>
        </>
    )
};